module.exports = __webpack_public_path__ + "img/icon-dapp-stakewise.cc89987d.svg";